// src/pages/Employees/components/EmployeeFormQuickNav.jsx
import React from "react";
import { Button } from "antd";
import { PANEL_CATEGORIES } from "./employeeFormPanelMeta";

// A row of category chips giving a new user an at-a-glance map of what this
// long form contains, and a way to jump straight to a section. Purely
// additive on top of the existing Collapse — doesn't change how any panel
// header behaves, so it carries no risk to the Playwright suite, which only
// ever interacts with panel headers/fields directly.
const EmployeeFormQuickNav = ({ onNavigate }) => (
  <div
    style={{
      display: "flex",
      flexWrap: "wrap",
      gap: 8,
      marginBottom: 16,
      padding: "12px 14px",
      background: "#fafafa",
      border: "1px solid #f0f0f0",
      borderRadius: 8,
    }}
  >
    {PANEL_CATEGORIES.map((cat) => (
      <Button key={cat.key} size="small" icon={cat.icon} onClick={() => onNavigate(cat.firstPanelKey)}>
        {cat.label}
      </Button>
    ))}
  </div>
);

export default EmployeeFormQuickNav;
